import React from 'react';
import {Footer, HeaderNavi, SupportLeftMenu, FileList} from '@components';
import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';
import { useNavigate, useLocation } from 'react-router-dom';

const fetchReferenceDetail = async (referenceId) => {
    const response = await get(`/reference/${referenceId}`);
    return response;
};
const ReferenceDetail = () => {
    const location = useLocation();
    const navigate = useNavigate()

    const params = new URLSearchParams(location.search);
    const referenceId = params.get('referenceId');

    const { data, isLoading, isError } = useQuery({
        queryKey: ['referenceDetail', referenceId],
        queryFn: () => fetchReferenceDetail(referenceId),
        enabled: !!referenceId,
    });

    if (isLoading) {
        return <div>로딩 중...</div>;
    }

    if (isError) {
        return <div>오류가 발생했습니다.</div>;
    }

    const detail = data?.result;

  return (
    <main id="main" className="mainpage">
            <>
            <div>
                <div className="section main-contact">
                    <HeaderNavi  selectedCategory  />
                    <div className="sub-container">
                        <div className="sub-layout">
                            <SupportLeftMenu />
                            <div className="sub-contact">
                                <h3 className="border-bt" style={{ marginBottom: '0' }}>자료실</h3>
                                <div className="lineTop_tb01">
                                    <table className="lineTop_tb2 detail_tb">
                                    <colgroup>
                                        <col style={{ width: '130px' }} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>제목</th>
                                            <td>{detail?.title}</td>
                                        </tr>
                                        <tr>
                                            <th>작성일</th>
                                            <td>{detail?.regDtm}</td>
                                        </tr>
                                        <tr>
                                            <th>파일</th>
                                            <td >
                                                <FileList 
                                                atchFileId={detail.atchFileId} 
                                                showDelete={false} 
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>내용</th>
                                            <td className="content_area" style={{height:"100px"}}>
                                                {detail?.content}
                                            </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                                <button
                                        className="btn btn-bl mt10 ml10"
                                        onClick={() => navigate('/support/reference')}
                                    >
                                        목록
                                    </button>
                            </div>	
                        </div>	
                    </div>
                    <Footer />
                </div>
            </div>
        </>
   </main>


  );
};


export default ReferenceDetail;
